/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentMessageTemplateReorderRequest model module.
 * @module model/AgentMessageTemplateReorderRequest
 * @version 1.0.0
 */
class AgentMessageTemplateReorderRequest {
    /**
     * Constructs a new <code>AgentMessageTemplateReorderRequest</code>.
     * @alias module:model/AgentMessageTemplateReorderRequest
     * @param templateId {Number} 移動するテンプレートID
     * @param targetId {Number} 挿入先のテンプレートID
     * @param position {module:model/AgentMessageTemplateReorderRequest.PositionEnum} 挿入位置
     */
    constructor(templateId, targetId, position) { 
        
        AgentMessageTemplateReorderRequest.initialize(this, templateId, targetId, position);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, templateId, targetId, position) { 
        obj['template_id'] = templateId;
        obj['target_id'] = targetId;
        obj['position'] = position;
    }

    /**
     * Constructs a <code>AgentMessageTemplateReorderRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentMessageTemplateReorderRequest} obj Optional instance to populate.
     * @return {module:model/AgentMessageTemplateReorderRequest} The populated <code>AgentMessageTemplateReorderRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentMessageTemplateReorderRequest();

            if (data.hasOwnProperty('template_id')) {
                obj['template_id'] = ApiClient.convertToType(data['template_id'], 'Number');
            }
            if (data.hasOwnProperty('target_id')) {
                obj['target_id'] = ApiClient.convertToType(data['target_id'], 'Number');
            }
            if (data.hasOwnProperty('position')) {
                obj['position'] = ApiClient.convertToType(data['position'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentMessageTemplateReorderRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentMessageTemplateReorderRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentMessageTemplateReorderRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['position'] && !(typeof data['position'] === 'string' || data['position'] instanceof String)) {
            throw new Error("Expected the field `position` to be a primitive type in the JSON string but got " + data['position']);
        }

        return true;
    }


}

AgentMessageTemplateReorderRequest.RequiredProperties = ["template_id", "target_id", "position"];

/**
 * 移動するテンプレートID
 * @member {Number} template_id
 */
AgentMessageTemplateReorderRequest.prototype['template_id'] = undefined;

/**
 * 挿入先のテンプレートID
 * @member {Number} target_id
 */
AgentMessageTemplateReorderRequest.prototype['target_id'] = undefined;

/**
 * 挿入位置
 * @member {module:model/AgentMessageTemplateReorderRequest.PositionEnum} position
 */
AgentMessageTemplateReorderRequest.prototype['position'] = undefined;





/**
 * Allowed values for the <code>position</code> property.
 * @enum {String}
 * @readonly
 */
AgentMessageTemplateReorderRequest['PositionEnum'] = {

    /**
     * value: "before"
     * @const
     */
    "before": "before",

    /**
     * value: "after"
     * @const
     */
    "after": "after"
};



export default AgentMessageTemplateReorderRequest;

